export default "__VITE_ASSET__BKB_UZPg__"